import createContactValidationSchema from './create-contact';
import updateContactValidationSchema from './update-contact';
import uploadContacts from './upload-contacts';

export default {
  createContactValidationSchema,
  updateContactValidationSchema,
  uploadContacts,
};
